module.exports = __webpack_public_path__ + "static/media/desktop.d4e7c54.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Nails/desktop.mp4
// module id = wp3y
// module chunks = 1